import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UsersnapService } from '../../services/usersnap.service';
import { SubjectService } from '../../services/subject.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  isDropdownOpen: boolean = false;
  isToggle: boolean = false;
  name: string = "";
  public selectedLanguage: string = 'en';
  public dropdownOpen: boolean = false;
  private userId: string | null = null;
  role = 0;
  customerNumber: string = "";

  @Output() toggleSidebar = new EventEmitter();
  @Output() smallSidebar = new EventEmitter();

  constructor(private router: Router, private cookieService: CookieService, private translate: TranslateService, private usersnapService: UsersnapService, private subject: SubjectService) {
    const savedLang = this.cookieService.get('language') || 'en';
    this.selectedLanguage = savedLang;
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
  }

  open2FAModal() {
    this.subject.open2FAModal$.next();
  }



  ngOnInit(): void {
    this.getName();
    if (this.cookieService.get('user')) {
      this.role = JSON.parse(this.cookieService.get('user')).role;
      this.customerNumber = JSON.parse(this.cookieService.get('user')).customerNumber;
    }
  }


  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  sideMenu() {
    this.toggleSidebar.emit();
  }

  toggleMenu() {
    this.isToggle = !this.isToggle;
    this.smallSidebar.emit();
  }

  logout() {
    this.router.navigate([
      '/auth/login'
    ])
    this.cookieService.delete('token');
    this.cookieService.delete('user');
    this.usersnapService.authSubject.next(null);
  }

  getName() {
    const userCookie = this.cookieService.get('user');

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie);
        this.name = user.firstName + " " + user.lastName;
        this.userId = user.id;
      } catch (error) {
        console.error('Error parsing user cookie:', error);
      }
    }
  }

  toggleLangugaeDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  switchLanguage(language: string) {
    this.translate.use(language);
    this.selectedLanguage = language;
    this.dropdownOpen = false;
    this.cookieService.set('language', language)
  }

  goToProfile() { // Debugging

    if (this.userId) {
      this.router.navigate(['/profile/' + this.userId]);
    } else {
      console.error('User ID is missing in the HeaderComponent.');
    }
  }

  openBugWidget() {
    this.usersnapService.bugWidgetSubject.next(true);
  }

}
